// nestjs copy
function applyDecorators(...decorators) {
    return (target, propertyKey, descriptor)=>{
        for (const decorator of decorators){
            if (target instanceof Function && !descriptor) {
                decorator(target);
                continue;
            }
            // @ts-ignore
            decorator(target, propertyKey, descriptor);
        }
    };
}

export { applyDecorators as a };
//# sourceMappingURL=applyDecorators_chunkExport-D6nMF0T1.mjs.map
